/** Count helpers for `pdfengine.imposition.packing.fill` ports. */

import type { ORXY, XY } from "../types/matrix"

export const BLANK_MATRIX: XY = { x: 0, y: 0 }

export const BLANK_NESTED: ORXY = { x: BLANK_MATRIX, y: BLANK_MATRIX }

export const xy_len = (m: XY): number => m.x * m.y

// Mirrors python ORXYMatrix.__bool__:
//   bool(self.x or self.y)  where x/y are XYMatrix
// and XYMatrix.__bool__ delegates to len(self) = x*y.
// JS truthiness on objects is always true, so without this the
// rotated best_fill case loses to non-rotated on the has_flip
// tiebreaker (a flipped block with zero cells gets counted as
// truthy and the strategy is mislabeled has_flip=True).
export const orxy_bool = (m: ORXY): boolean => xy_bool(m.x) || xy_bool(m.y)

export const xy_bool = (m: XY): boolean => Boolean(xy_len(m))

export const sym_grow_rotate = (s: XY): XY => ({ x: s.y, y: s.x })
